import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'map-component',
  shadow: false
})
export class MapComponent {
  @Prop() items: any[] = [];

  /**
   * The render function to render each item.
   */
  @Prop() renderItem: (item: any, index: number) => any;

  render() {
    return <Host>{this.items?.map((item, index) => this.renderItem(item, index))}</Host>;
  }
}
